import { render, staticRenderFns } from "./RegisterModalForm.vue?vue&type=template&id=3941a3c7&scoped=true&"
import script from "./RegisterModalForm.vue?vue&type=script&lang=js&"
export * from "./RegisterModalForm.vue?vue&type=script&lang=js&"
import style0 from "./RegisterModalForm.vue?vue&type=style&index=0&id=3941a3c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3941a3c7",
  null
  
)

export default component.exports